export default __webpack_public_path__ + "static/media/s3_female.b00c7a81.wav";